const state = {
    exportRequestId: window.localStorage.getItem('exportRequestId')
};

const mutations = {
    'SET_EXPORT_REQUEST_ID' (state, id) {
        state.exportRequestId = id;
        window.localStorage.setItem('exportRequestId', id);
    },
    'DELETE_EXPORT_REQUEST_ID' (state) {
        state.exportRequestId = null;
        window.localStorage.removeItem('exportRequestId');
    }
};

const actions = {
    setExportRequestId({ commit }, id) {
        commit('SET_EXPORT_REQUEST_ID', id);
    },
    clearExportRequestId({ commit }) {
        commit('DELETE_EXPORT_REQUEST_ID');
    }
};

const getters = {
    exportRequestId: state => state.exportRequestId
};

export default {
    state,
    mutations,
    actions,
    getters
};